// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scrollbar container */
.BrNSWPpOGa_MupIj_RFF {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 5px 5px 0 5px;
  z-index: 10;
}
.B82uHgHZVQ7uTebuSGoA {
  position: relative;
  height: 100%;
  width: 14px;
}
/* Apply these styles to any range input inside our component */
.bzp5DLXrM7ne5sj3eiFd {
  position: absolute;
  left: 14px;
  top: 0;
  height: 14px;
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
  -webkit-transform-origin: top left;
          transform-origin: top left;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: transparent;
  padding: 0;
}
/* Thumb styles for WebKit browsers - more specific selector */
input[type='range'].bzp5DLXrM7ne5sj3eiFd::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  background-color: hsl(var(--neutral));
  opacity: 50%;
  border: none;
  border-radius: 57px;
  cursor: -webkit-grab;
  height: 12px;
  margin-top: -5px;
  width: 44px;
}
input[type='range'].bzp5DLXrM7ne5sj3eiFd::-webkit-slider-thumb:active,
input[type='range'].bzp5DLXrM7ne5sj3eiFd::-webkit-slider-thumb:hover {
  background-color: hsl(var(--primary));
  opacity: 60%;
  cursor: -webkit-grabbing;
}
/* Thumb styles for Firefox - more specific selector */
input[type='range'].bzp5DLXrM7ne5sj3eiFd::-moz-range-thumb {
  background-color: hsl(var(--neutral));
  opacity: 50%;
  border: none;
  border-radius: 57px;
  cursor: -moz-grab;
  height: 14px;
  width: 48px;
}
input[type='range'].bzp5DLXrM7ne5sj3eiFd::-moz-range-thumb:active,
input[type='range'].bzp5DLXrM7ne5sj3eiFd::-moz-range-thumb:hover {
  background-color: hsl(var(--primary));
  opacity: 50%;
  cursor: -moz-grabbing;
}
/* Track styles for WebKit browsers - more specific selector */
input[type='range'].bzp5DLXrM7ne5sj3eiFd::-webkit-slider-runnable-track {
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 7px;
}
/* Track styles for Firefox - more specific selector */
input[type='range'].bzp5DLXrM7ne5sj3eiFd::-moz-range-track {
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 4px;
}
/* Ensure focus doesn't show an outline */
.bzp5DLXrM7ne5sj3eiFd:focus {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/components/Viewport/ImageScrollbar.module.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,gCAAwB;UAAxB,wBAAwB;EACxB,kCAA0B;UAA1B,0BAA0B;EAG1B,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;AACZ;AAEA,8DAA8D;AAC9D;EACE,mCAAmC;EACnC,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AAEA;;EAEE,qCAAqC;EACrC,YAAY;EACZ,wBAAwB;AAC1B;AAEA,sDAAsD;AACtD;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AAEA;;EAEE,qCAAqC;EACrC,YAAY;EACZ,qBAAqB;AACvB;AAEA,8DAA8D;AAC9D;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AAEA,sDAAsD;AACtD;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AAEA,yCAAyC;AACzC;EACE,aAAa;AACf","sourcesContent":["/* Scrollbar container */\r\n.scrollbarContainer {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  height: 100%;\r\n  padding: 5px 5px 0 5px;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbarInner {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 14px;\r\n}\r\n\r\n/* Apply these styles to any range input inside our component */\r\n.scrollbarInput {\r\n  position: absolute;\r\n  left: 14px;\r\n  top: 0;\r\n  height: 14px;\r\n  transform: rotate(90deg);\r\n  transform-origin: top left;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  background-color: transparent;\r\n  padding: 0;\r\n}\r\n\r\n/* Thumb styles for WebKit browsers - more specific selector */\r\ninput[type='range'].scrollbarInput::-webkit-slider-thumb {\r\n  -webkit-appearance: none !important;\r\n  background-color: hsl(var(--neutral));\r\n  opacity: 50%;\r\n  border: none;\r\n  border-radius: 57px;\r\n  cursor: -webkit-grab;\r\n  height: 12px;\r\n  margin-top: -5px;\r\n  width: 44px;\r\n}\r\n\r\ninput[type='range'].scrollbarInput::-webkit-slider-thumb:active,\r\ninput[type='range'].scrollbarInput::-webkit-slider-thumb:hover {\r\n  background-color: hsl(var(--primary));\r\n  opacity: 60%;\r\n  cursor: -webkit-grabbing;\r\n}\r\n\r\n/* Thumb styles for Firefox - more specific selector */\r\ninput[type='range'].scrollbarInput::-moz-range-thumb {\r\n  background-color: hsl(var(--neutral));\r\n  opacity: 50%;\r\n  border: none;\r\n  border-radius: 57px;\r\n  cursor: -moz-grab;\r\n  height: 14px;\r\n  width: 48px;\r\n}\r\n\r\ninput[type='range'].scrollbarInput::-moz-range-thumb:active,\r\ninput[type='range'].scrollbarInput::-moz-range-thumb:hover {\r\n  background-color: hsl(var(--primary));\r\n  opacity: 50%;\r\n  cursor: -moz-grabbing;\r\n}\r\n\r\n/* Track styles for WebKit browsers - more specific selector */\r\ninput[type='range'].scrollbarInput::-webkit-slider-runnable-track {\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  height: 7px;\r\n}\r\n\r\n/* Track styles for Firefox - more specific selector */\r\ninput[type='range'].scrollbarInput::-moz-range-track {\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  height: 4px;\r\n}\r\n\r\n/* Ensure focus doesn't show an outline */\r\n.scrollbarInput:focus {\r\n  outline: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollbarContainer": `BrNSWPpOGa_MupIj_RFF`,
	"scrollbarInner": `B82uHgHZVQ7uTebuSGoA`,
	"scrollbarInput": `bzp5DLXrM7ne5sj3eiFd`
};
export default ___CSS_LOADER_EXPORT___;
